import client from './client';

export const faqApi = {
  list: (univers) => client.get(`/faqs${univers ? `?univers=${univers}` : ''}`, { auth: false }),

  // Back Office
  adminList: () => client.get('/admin/faqs'),
  create: (data) => client.post('/admin/faqs', data),
  update: (id, data) => client.put(`/admin/faqs/${id}`, data),
  remove: (id) => client.delete(`/admin/faqs/${id}`),
};

export const temoignagesApi = {
  list: (univers) => client.get(`/temoignages${univers ? `?univers=${univers}` : ''}`, { auth: false }),
  submit: (data) => client.post('/temoignages', data, { auth: false }),

  // Back Office
  adminList: () => client.get('/admin/temoignages'),
  create: (data) => client.post('/admin/temoignages', data),
  moderate: (id, statut) => client.put(`/admin/temoignages/${id}`, { statut }),
  update: (id, data) => client.put(`/admin/temoignages/${id}/contenu`, data),
  remove: (id) => client.delete(`/admin/temoignages/${id}`),
};

export const articleCategoriesApi = {
  list: () => client.get('/article-categories', { auth: false }),

  // Back Office
  create: (nom) => client.post('/admin/article-categories', { nom }),
  remove: (id) => client.delete(`/admin/article-categories/${id}`),
};

export const settingsApi = {
  public: () => client.get('/settings', { auth: false }),

  // Back Office
  adminGet: () => client.get('/admin/settings'),
  update: (data) => client.put('/admin/settings', data),
};

export const menusApi = {
  get: (emplacement) => client.get(`/menus/${emplacement}`, { auth: false }),
};

export const zonesApi = {
  search: (query) => client.get(`/zones?q=${encodeURIComponent(query)}`, { auth: false }),
};
